<div class="flymsg-row-editor">
  <div class="expand-form">
    <div class="fms-shortcuts-try-it-out-wrapper" style="flex: 1 1 100%; max-width: 38%">
      <!-- V4-02 (#413): "Try it out" is projected into vng-input's own
           `[vngSuffix]` slot, so it renders INSIDE the field's control box
           pinned to its right edge — master's layout (an absolutely
           positioned overlay over the mat-form-field, with the infix padded
           `padding-right: 86px` to keep the value off it). The suffix slot
           lives inside `.vng-input__container` (`display:flex; height:40px;
           padding:0 12px; gap:8px`), and `.vng-input__field` is
           `flex:1; min-width:0` — so the text area shrinks to make room and
           the "extra right padding" falls out of the flex layout, with no
           `!important` reach into library internals and nothing to keep
           re-aligned across breakpoints. -->
      <vng-input [label]="flyCutLabel" [placeholder]="flyCutPlaceholder" type="text" [ngModel]="flyCutValue"
        (ngModelChange)="onFlyCutInput($event)" [ngModelOptions]="{ standalone: true }" [flyMsgIgnore]="true"
        [required]="flyCutRequired" [disabled]="flyCutDisabled" [error]="flyCutError" [info]="flyCutHelpText">
        <button *ngIf="showTryItOut" vngSuffix vng-button variant="outline" size="sm" type="button"
          class="fms-shortcuts-try-it-out-button" (click)="tryItOut.emit()" [vngTourAnchor]="tryItOutTourAnchor"
          [attr.data-fms-heap]="tryItOutHeapAttr || null" vngTooltip="Try it out" vngTooltipPosition="top">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.65997 6.64023H6.20497V10.2402C6.20497 10.7702 6.86496 11.0202 7.21496 10.6202L11 6.32023C11.33 5.94523 11.065 5.36023 10.565 5.36023H9.01997V1.76023C9.01997 1.23023 8.35996 0.980229 8.00996 1.38023L4.22497 5.68023C3.89997 6.05523 4.16497 6.64023 4.65997 6.64023Z"
              stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.25 2H0.75" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M3.75 10H0.75" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M2.25 6H0.75" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="tio-label">Try it out</span>
        </button>
      </vng-input>
    </div>

    <vng-input [label]="titleLabel" [placeholder]="titlePlaceholder" style="flex: 1 1 100%; max-width: 48%" type="text"
      [ngModel]="titleValue" (ngModelChange)="onTitleInput($event)" [ngModelOptions]="{ standalone: true }"
      [flyMsgIgnore]="true" [required]="titleRequired" [disabled]="titleDisabled" [error]="titleError"
      [info]="titleHelpText">
    </vng-input>

    <!-- V4-01: the usage/version clock badge belongs HERE, in the expanded
         body — master rendered it as its own column between Title/Description
         and the Action select on BOTH hosts (`fxFlex="4"` on FlyCuts, see
         git show staging:src/app/vengreso/shortcuts/shortcuts.component.html;
         the same block on the dashboard row). It was dropped at 12293bda on
         the theory that the collapsed header's own badge stays visible while
         the row is open — true at the time, but V3-01 then had to hide that
         header while expanded to reproduce master's `expandedHeight="35px"`
         strip, so the count disappeared from the expanded row altogether.
         Restored as master had it: the bare icon + count, NOT the collapsed
         header's grey pill (that pill is the header's own styling — master's
         expanded row shows no pill background, see
         artifacts/old/_t.dlg.flymsg-row-editor). -->
    <div class="expand-version" *ngIf="showVersionColumn">
      <p [vngTooltip]="versionLabel + ' (' + (versionCount || 0) + ')'" vngTooltipPosition="top">
        <img src="assets/images/Clock.png" alt="" (click)="versionClick.emit()" />
        <span (click)="versionClick.emit()">{{ versionCount || 0 }}</span>
      </p>
    </div>

    <!-- V2-10: 120px left only ~72px for the trigger's value text, so the
         selected action came back clipped ("Word Co…", and "Version History"
         worse). mat-select never reflected the selection here (this is a fake
         actions menu), vng-select does — 160px is the widest option's natural
         width plus the chevron. -->
    <div class="row-action-select" *ngIf="showActionSelect">
      <vng-select style="width: 160px" label="Action" placeholder="Action" [options]="actionOptions"
        (selectionChange)="onActionSelection($event)">
        <ng-template #vngSelectOption let-opt>
          <img style="vertical-align: middle" [src]="opt.data.icon" alt="" />
          <span> {{ opt.label }}</span>
        </ng-template>
      </vng-select>
    </div>
  </div>

  <div class="text-title" *ngIf="showEditorLabel">
    <label class="font-weight-bold">{{ editorLabel }}</label>
    <vng-icon *ngIf="editorHelpText" name="help_center" [outline]="false" color="purple" class="help-icon"
      [ngbPopover]="editorHelpText"></vng-icon>
  </div>

  <ng-content select="[editor]"></ng-content>

  <div *ngFor="let err of errors">
    <p class="warn-txt">
      <img style="vertical-align: bottom" src="assets/images/warning.png" alt="" />
      <span> {{ err }}</span>
    </p>
  </div>

  <div class="panel-action-row" *ngIf="showSavingNote || showDefaultActions">
    <div class="saving-note" *ngIf="showSavingNote" [ngClass]="isSaving ? 'saving' : 'saved'">
      <span class="saving-note__status">{{ savingStatusText }}</span>
      <div class="saving-note__reminder">
        <vng-icon name="info" [outline]="false" color="error" class="info-icon"></vng-icon>
        <span class="saving-note__reminder-text">{{ savingReminderText }}</span>
      </div>
    </div>

    <div class="expand-btns" *ngIf="showDefaultActions">
      <button *ngIf="showDuplicate" class="hide-on-mobile" type="button" vng-button variant="outline"
        (click)="duplicate.emit()" aria-label="duplicate flyCut">
        <svg-icon-sprite width="18px" height="18px" src="icon-ico-copy"></svg-icon-sprite>
        Duplicate FlyMSG
      </button>
      <button *ngIf="showDuplicate" class="row-action-fab hide-on-desktop" type="button" vng-button variant="ghost"
        size="sm" (click)="duplicate.emit()" aria-label="duplicate flyCut" vngTooltip="Duplicate FlyCut"
        vngTooltipPosition="top">
        <svg-icon-sprite width="18px" height="18px" src="icon-ico-copy"></svg-icon-sprite>
      </button>

      <button *ngIf="showChangeCategory" class="hide-on-mobile" type="button" vng-button variant="outline"
        (click)="changeCategory.emit()" aria-label="change category">
        <svg-icon-sprite width="18px" height="18px" src="icon-ico-change"></svg-icon-sprite>
        Change Category
      </button>
      <button *ngIf="showChangeCategory" class="row-action-fab hide-on-desktop" type="button" vng-button
        variant="ghost" size="sm" (click)="changeCategory.emit()" aria-label="change category"
        vngTooltip="Change Category" vngTooltipPosition="top">
        <svg-icon-sprite width="18px" height="18px" src="icon-ico-change"></svg-icon-sprite>
      </button>

      <button class="hide-on-mobile" type="button" vng-button variant="primary" (click)="delete.emit()"
        aria-label="delete">
        <svg-icon-sprite width="16px" height="16px" src="icon-ico-delete"></svg-icon-sprite>
        Delete
      </button>
      <button class="row-action-fab hide-on-desktop" type="button" vng-button variant="primary" size="sm"
        (click)="delete.emit()" aria-label="delete" vngTooltip="Delete Shortcut" vngTooltipPosition="top">
        <svg-icon-sprite width="16px" height="16px" src="icon-ico-delete"></svg-icon-sprite>
      </button>
    </div>
  </div>
</div>